import '../scss/app.scss';

require('./app-bootstrap'); // Объявление многих переменных в window

/** header components * */

App.vue.setComponent(require('./components/Banners/TopMessageBanner').default);

App.vue.setComponent(
  require('./components/Cabinet/RegistrationControl/RegistrationControl.vue').default
);
App.vue.setComponent(require('./components/Cities/Cities.vue').default);
App.vue.setComponent(require('./components/Def/DefLang/DefLang.vue').default);
App.vue.setComponent(require('./components/Menus/MenuMobile.vue').default);
App.vue.setComponent(require('./components/Search/SearchEngineTop/SearchEngineTop.vue').default);
App.vue.setComponent(require('./components/Basket/SmallBasket.vue').default);
App.vue.setComponent(require('./components/Menus/VueMenu/VueMenu.vue').default);
App.vue.setComponent(require('./components/bootstrap/Favourite.vue').default);
App.vue.setComponent(require('./components/forms/NewsSubscribe.vue').default);
App.vue.setComponent(require('./components/sliders/WhyLoveYou.vue').default);
App.vue.setComponent(require('./components/sliders/Bestsellers.vue').default);
App.vue.setComponent(require('./components/sliders/JewelrySlider.vue').default);
App.vue.setComponent(require('./components/Seo/SeoText.vue').default);

/** Footer components * */
App.vue.setComponent(require('./components/Def/DefSubscribe/DefSubscribe.vue').default);
App.vue.setComponent(require('./components/Footer/Footer.vue').default);

// scripts
require('./love-you/app');

// require('./on-document-ready'); // Скрипты которые нужно пнуть после загрузки страницы
